import React, { useRef } from "react";
import "./loyaltyFormModal.css";
import { toast } from "react-toastify";

const LoyaltyFormModal = ({ onClose }) => {
  const form = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData(form.current);
    const data = {
      name: formData.get("name"),
      phone: formData.get("phone"),
      email: formData.get("email"),
      address: formData.get("address")
    };
  
    try {
      const res = await fetch("https://rcsbackend.onrender.com/send-loyalty", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });
  
      const result = await res.json();
      if (result.success) {
        toast.success("✅ Your loyalty signup was submitted! Thank You!");
        form.current.reset();
        onClose();
      } else {
        toast.error("❌ Submission failed.");
      }
    } catch (err) {
      console.error("❌ Server error:", err);
      toast.error("❌ Could not send form. Try again.");
    }
  };
  

  return (
<div className="loyalty-modal">
  <div className="modal-content">
          <h3>🎉 Loyalty Program Sign-Up</h3>
          <form ref={form} onSubmit={handleSubmit}>
  <input name="name" type="text" placeholder="Full Name" required />
  <input name="phone" type="tel" placeholder="Phone Number" required />
  <input name="email" type="email" placeholder="Email Address" />
  <input name="address" type="text" placeholder="Address" required />

  <button type="submit" className="submit-btn">Submit</button>
  <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
</form>

      </div>
    </div>
  );
};

export default LoyaltyFormModal;
